import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';
import { KeylessonDetailComponent } from './keylesson-detail/keylesson-detail.component';
import { KeylessonListComponent } from './keylesson-list/keylesson-list.component';
import { KeylessonPlayerResolverService } from './keylesson-player-resolver.service';
import { KeylessonPlayerComponent } from './keylesson-player/keylesson-player.component';
import { KeylessonResolverService } from './keylesson-resolver.service';


const routes: Routes = [  
  {
    path: '',
    component: KeylessonListComponent,
    canActivate: [AuthGuard],
    children: [
      
    ]
  },
  {
    path: ':id',
    component: KeylessonDetailComponent,
    canActivate: [AuthGuard],
    resolve: {
      lesson: KeylessonResolverService
    },
    children: [
      {
        path: 'player',
        component: KeylessonPlayerComponent,
        resolve: {
          keys: KeylessonPlayerResolverService
        },
      }
    ]
  }
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KeylessonRoutingModule { }
